export const queryPage = '/icps/system/sign/supplierSystem/facility/QueryPage'
export const batchUpdateOrDelete = '/icps/system/sign/supplierSystem/facility/deletes'
export const updateSortNum = ''
export const saveOrUpdate = '/icps/system/sign/supplierSystem/facility/saveOrUpdate'
export const Download = '/icps/system/sign/supplierSystem/facility/exportList '


